<ng-container *transloco="let t">
  <tui-stepper class="flex gap-2" [activeItemIndex]="step" (activeItemIndexChange)="onStepChange($event)">
    <button tuiStep type="button">{{ t('Détails') }}</button>
    <button tuiStep type="button">{{ t('Rapport') }}</button>
    <button tuiStep type="button" [disabled]="step !== PatientTeleexpertiseStep.RESULT">{{ t('Résultat') }}</button>
  </tui-stepper>

  <div class="flex flex-1 flex-col gap-4">
    <section class="flex flex-1 flex-col" pxcSlidesScrollReset [tuiSlides]="slideDirection">
      @if (step === PatientTeleexpertiseStep.INFORMATIONS) {
        <div class="flex flex-col gap-4">
          <pxc-patient-card data-testid="patient" [patient]="patient" />
          <label tuiLabel>
            {{ t('Message personnalisé') }}
            <tui-textfield data-testid="label-message">
              <textarea
                data-testid="input-message"
                tuiTextarea
                [max]="10"
                [min]="5"
                [placeholder]="t('Saisir un message personnalisé')"
                [(ngModel)]="message"></textarea>
            </tui-textfield>
          </label>
        </div>
      }

      @if (step === PatientTeleexpertiseStep.REPORT) {
        <pxc-patient-report-document
          class="sm:h-[70vh]"
          [clientCode]="clientCode"
          [departmentIds]="departmentId ? [departmentId] : []"
          [patient]="patient" />
      }

      @if (step === PatientTeleexpertiseStep.RESULT) {
        <div class="flex flex-col gap-4">
          <label tuiLabel>
            {{ t('Lien de téléexpertise') }}
            <tui-textfield data-testid="label-link">
              <input data-testid="input-link" tuiInput [disabled]="true" [value]="redirectUrl" />
            </tui-textfield>
          </label>
          <div class="flex gap-2 max-md:flex-col">
            <button
              appearance="outline"
              data-testid="button-copy-link"
              iconStart="@tui.copy"
              tuiButton
              type="button"
              [copySuccessMessage]="t('Lien copié dans le presse-papiers')"
              [copyToClipboard]="redirectUrl">
              {{ t('Copier le lien') }}
            </button>
            <button
              appearance="primary"
              data-testid="button-open-link"
              iconEnd="@tui.external-link"
              tuiButton
              type="button"
              (click)="openLink()">
              {{ t('Ouvrir dans un nouvel onglet') }}
            </button>
          </div>
        </div>
      }
    </section>
    <footer class="mt-auto!" tuiFloatingContainer>
      <div class="flex gap-2 max-md:flex-col-reverse md:justify-between">
        <button appearance="outline" tuiButton type="button" (click)="previous()">
          {{
            step === PatientTeleexpertiseStep.INFORMATIONS
              ? t('Annuler')
              : step === PatientTeleexpertiseStep.RESULT
                ? t('Fermer')
                : t('Retour')
          }}
        </button>
        @if (step !== PatientTeleexpertiseStep.RESULT) {
          <button
            appearance="primary"
            tuiButton
            type="button"
            [disabled]="step === PatientTeleexpertiseStep.REPORT && patientReportDocumentService.form.valid === false"
            (click)="next()">
            {{ step === PatientTeleexpertiseStep.REPORT ? t('Créer') : t('Suivant') }}
          </button>
        }
      </div>
    </footer>
  </div>

  <ng-template [(tuiNotificationMiddle)]="isSubmitting">
    <tui-loader tuiAnimated />
    <div class="text-center" tuiAnimated>
      {{ t('Téléexpertise avec {{ provider }} en cours...', { provider: (teleexpertiseProviderType |
      teleexpertiseProvider) }) }}
    </div>
  </ng-template>
</ng-container>
